export default __webpack_public_path__ + "static/rabbi-book-shelf-mobile-a1b4e5474dc519a2246e1b9046a7837c.jpg";